import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WhatsAppNewClientService {

  constructor(private http: HttpClient) { }



  url = environment.serverAPI9 + "/api/conversations";

  getAllWhatsAppChat(page: number, size: number, phoneNo: string): Observable<any> {
    const params = new HttpParams()
      .set('limit', size)
      .set('offset', page);

    return this.http.get(`${this.url}/${phoneNo}`, { params });
  }

}
